import { format } from "date-fns";
import { CheckCheck, Loader2, Mail, RotateCw, Save, Scaling, X } from "lucide-react";
import React, { useContext } from "react";
import Icon from "~/components/Icon";

// import { Container } from './styles';

export default function FormHeader({
  loading = false,
  saveText = "Save changes",
  saveColor = null,
  saveIcon = "Save",
  outside = false,
  flexibleHeight = false,
  access = {
    view: false,
    edit: false,
    create: false,
    inactivate: false,
    MenuHierarchyXGroup: null,
  },
  title = "",
  registry = { registryBy: null, registryAt: null, registryStatus: null },
  InputContext = null,
  emailButtonText = "Send Mail",
  createText = "Create",
  createIcon = <Save size={16} />,
  enableFullScreen = true,
  onRefresh = null,
  refreshing = false,
  refreshDisabled = false,
  otherButtons = null,
  disableSave = false,
}) {
  const { registryBy, registryAt, registryStatus } = registry;
  const {
    id,
    fullscreen,
    setFullscreen,
    successfullyUpdated,
    handleCloseForm,
    handleOutsideMail,
  } = useContext(InputContext);

  if (access?.MenuHierarchyXGroup) {
    access = access.MenuHierarchyXGroup;
  }

  return (
    <div className={`sticky top-0 z-50 bg-slate-100 mb-4 px-4 py-4 flex flex-row flex-wrap items-center justify-between w-full gap-2 ${outside ? "min-h-16" : flexibleHeight ? "min-h-24 py-8" : "h-24 py-8"}`}>
      <h2
        className={`flex flex-col justify-start items-start gap-1 min-w-0 shrink ${outside ? "text-sm font-semibold" : ""}`}
        style={{ fontSize: outside ? undefined : 24 }}
      >
        {title}{" "}
        <span className="text-xs">
          {registryAt &&
            `${registryStatus} by ${registryBy} on ${format(
              registryAt,
              "LLL do, yyyy @ HH:mm"
            )}`}
        </span>
      </h2>

      <div className="flex flex-row flex-wrap justify-end items-center gap-2">
        {loading ? (
          <div className="flex flex-row justify-center items-center gap-2">
            <Loader2 size={16} color="#111" className="animate-spin" />
            <div>Please wait...</div>
          </div>
        ) : (
          <>
            {!outside && access && (
              <>
                {onRefresh && (
                  <button
                    type="button"
                    onClick={onRefresh}
                    disabled={refreshing || refreshDisabled}
                    title={refreshDisabled ? "Save or discard changes before refreshing" : "Refresh enrollment"}
                    className="text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md p-4 h-6 flex flex-row items-center justify-center text-xs gap-1 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <RotateCw size={16} className={refreshing ? "animate-spin" : ""} />
                    {refreshing ? "Refreshing..." : "Refresh"}
                  </button>
                )}
                {enableFullScreen && (
                  <button
                    type="button"
                    onClick={() => setFullscreen(!fullscreen)}
                    className="text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md p-4 h-6 flex flex-row items-center justify-center text-xs gap-1"
                  >
                    <Scaling size={16} />{" "}
                    {fullscreen ? "Minimize" : "Full Screen"}
                  </button>
                )}
                {(access.edit && id !== "new") ||
                (access.create && id === "new") ? (
                  <button
                    type="button"
                    onClick={() => handleCloseForm()}
                    className="text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md p-4 h-6 flex flex-row items-center justify-center text-xs gap-1"
                  >
                    <X size={16} />{" "}
                    {successfullyUpdated
                      ? "Close"
                      : "Discard changes not saved"}
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => handleCloseForm()}
                    className="text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md p-4 h-6 flex flex-row items-center justify-center text-xs gap-1"
                  >
                    <X size={16} /> Close
                  </button>
                )}
              </>
            )}
            {(outside || (access && access.create)) && id === "new" && (
              <button
                type="submit"
                disabled={loading}
                className={`text-md font-bold ${
                  !successfullyUpdated ? "bg-red-500" : "bg-primary"
                } text-white rounded-md p-4 h-6 flex flex-row items-center justify-center text-xs gap-1 disabled:opacity-50 disabled:cursor-not-allowed`}
              >
                <>
                  {createIcon} {createText}
                </>
              </button>
            )}
            {otherButtons &&
              otherButtons.map((button, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={button.onClick}
                  className={`text-md font-bold border border-dashed border-red-500 text-red-500 rounded-md p-4 h-6 flex flex-row items-center justify-center text-xs gap-1`}
                >
                  <>
                    <Icon name={button.icon} size={16} /> {button.text}
                  </>
                </button>
              ))}
            {(outside || (access && access.edit)) && id !== "new" && !disableSave && (
              <button
                type="submit"
                disabled={loading}
                className={`text-md font-bold ${
                  !successfullyUpdated
                    ? saveColor
                      ? saveColor
                      : "bg-red-500"
                    : "bg-primary"
                } text-white rounded-md p-4 h-6 flex flex-row items-center justify-center text-xs gap-1 disabled:opacity-50 disabled:cursor-not-allowed`}
              >
                {!successfullyUpdated ? (
                  <>
                    <Icon name={saveIcon} size={16} color="white" /> {saveText}
                  </>
                ) : (
                  <>
                    <CheckCheck size={16} /> {"Saved"}
                  </>
                )}
              </button>
            )}
            {!outside && handleOutsideMail && id !== "new" && (
              <button
                type="button"
                onClick={() => handleOutsideMail()}
                className="text-md font-bold bg-secondary border hover:border-primary hover:text-primary rounded-md p-4 h-6 flex flex-row items-center justify-center text-xs gap-1"
              >
                <Mail size={16} /> {emailButtonText}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
